export default {"src":"/_next/static/image/public/images/flags/flag_232.d7ecad8697e712682c65c687f1df567b.svg","height":16,"width":24};